<div>
    <img [ngStyle]="style" src="/assets/loading-spinner.svg" alt="loading-spinner">
</div>